import React from "react";
import styled from "styled-components/macro";
import BottomServiceBanner from "../../../components/ServiceBanner/BottomServiceBanner";
import TopServiceBanner from "../../../components/ServiceBanner/TopServiceBanner";
import banner from "../../../assets/images/PartBD/Medicare Banner-what you need to know_2.png";
import { BiChevronsRight } from "react-icons/bi";
import BottomBanner from "../../../components/ServiceBanner/BottomBanner";
import img1 from "../../../assets/images/personalattention/sr-img-ftr-switch.jpg";
import img2 from "../../../assets/images/personalattention/88434-text-symbol-question-mark-computer-graphics-3d.png";
// import Aos from "aos";
// import "aos/dist/aos.css";
// import { useEffect } from "react";
import img3 from "../../../assets/images/personalattention/1.png"
import img4 from "../../../assets/images/personalattention/2.png"
import img5 from "../../../assets/images/personalattention/3.png"
import img6 from "../../../assets/images/personalattention/4.png"

const personalAttention = [
  {
    id: 1,
    img: img3,
    title: "Overall satisfaction",
    dataaos: "slide-right",
  },
  {
    id: 2,
    img: img4,
    title: "Speed and accuracy",
    dataaos: "slide-up",
  },
  {
    id: 3,
    img: img5,
    title: "Courtesy and helpfulness",
    dataaos: "slide-down",
  },
  {
    id: 4,
    img: img6,
    title: "Pharmacist’s knowledge",
    dataaos: "slide-left",
  },
];


const PersonalAttention = () => {
  return (
    <Container>
      <TopServiceBanner title=" Personal Attention" banner={banner} />
      <Inner>
        <Title>Get Customers to Switch to Your Pharmacy</Title>
        <br />
        <br />
        <SubTitle>
          <b>
            Learn what Consumer Reports says customers value in independent
            pharmacies and use these strengths in your marketing to compete for
            new patients
          </b>
        </SubTitle>
        <Title>What is your pharmacy great at?</Title>
        <SubTitle>
          In today’s crowded, highly competitive pharmacy market, as an
          independent pharmacy you have to continue to promote what makes you
          different than your competition to help get new patients.
          <br /> <br />
          The good news, according to a January 2014 Consumer Reports article,
          “Finding the Right Pharmacy”1 is that independent pharmacies
          (including the independently owned franchise chain Health Mart®) rank
          higher than competitors on several key areas. The Consumer Reports
          article advises consumers why they might consider switching
          pharmacies.{" "}
        </SubTitle>
        <Title>How Independent Pharmacies Stack Up</Title>
        <SubTitle>
          In the Consumer Reports survey of more than 33,000 consumers,
          independent pharmacies outranked all national retail pharmacy chains
          and mass merchandisers in terms of:
        </SubTitle>
        <CardContainer className="service__container">
          {personalAttention.map((item) => (
            <div  className="servicecard__container">
              <ImgContainer className="servicecard__image">
                <Img src={item.img} alt={item.title} />
              </ImgContainer>
              <div className="servicecard__info">
                <div className="servicecard__title">{item.title}</div>
                <span className="servicecard__id">{item.id}</span>
              </div>
            </div>
          ))}
        </CardContainer>

        <Middle>
          <MiddleTextLeft>
            Are You Going to the Best Pharmacy for You?
          </MiddleTextLeft>
          <MiddleSubTitle>Take this short quiz and find out:</MiddleSubTitle>
          <MiddleInner>
            <MiddleInnerLeft>
              <Ul>
                <Li>
                  <BiChevronsRight />
                  Can you easily consult with your pharmacist about medications?
                </Li>

                <Li>
                  <BiChevronsRight />
                  Do you have to wait for your prescriptions?
                </Li>
                <Li>
                  <BiChevronsRight />
                  Are your medications always in-stock?
                </Li>
                <Li>
                  <BiChevronsRight />
                  Do you have a chronic condition?
                </Li>
                <Li>
                  <BiChevronsRight />
                  Do you make lots of trips for your medications?
                </Li>
                <Li>
                  <BiChevronsRight />
                  Would you benefit from home delivery?
                </Li>
                <Li>
                  <BiChevronsRight />
                  Are your medications always in-stock?
                </Li>
                <Li>
                  <BiChevronsRight />
                  Could custom medication mixing or special packaging help you
                  better take your medications?
                </Li>
                <Li>
                  <BiChevronsRight />
                  Does your pharmacy offer screenings, immunizations and
                  wellness programs?
                </Li>
                <Li>
                  <BiChevronsRight />
                  Does your pharmacy offer to contact your doctor and/or insurer
                  when you have issues?
                </Li>
                <Li>
                  <BiChevronsRight />
                  Does your pharmacist know your name?
                </Li>
              </Ul>
              <MiddleSubTitle>
                When you join a Medicare drug plan, you'll give your Medicare
                Number and the date your Part A and/or Part B coverage started.
                This information is on your Medicare card.
              </MiddleSubTitle>
            </MiddleInnerLeft>
            <MiddleInnerRight>
              <Img src={img2} alt="?" />
            </MiddleInnerRight>
          </MiddleInner>
        </Middle>

        <Title>Reasons to Switch to Independents</Title>
        <SubTitle>
          In addition to higher overall consumer satisfaction, Consumer Reports
          offered several reasons why consumers might benefit from switching to
          an independent pharmacy:
        </SubTitle>
        <LSubTitle>
          1. <b> Greater expertise and more personal attention.</b> The Consumer
          Reports article highlights for consumers that establishing a good
          relationship with a pharmacist they trust is the primary reason to
          choose a drugstore. Lucinda Maine, CEO and executive vice president of
          the American Association of Colleges of Pharmacy, is quoted, “You can
          and should expect your pharmacist to be both accessible and
          knowledgeable. If he or she is not, then you should take your business
          elsewhere.” <br />
          Ninety-four percent of survey participants gave their independent
          pharmacists high marks in knowledge. Customers of independent
          pharmacies also praised their pharmacist’s accessibility and personal
          service, and reported they were much more likely to discuss their
          prescriptions with a pharmacist. In contrast, customers of large chain
          pharmacies often found it difficult to communicate with pharmacists,
          at times because they thought the pharmacists seemed too busy.
          <br />
          <br />
          2. <b>Shorter wait times.</b> Customers are much less likely to have
          to wait for prescriptions at independent pharmacies than elsewhere.
          Only 7% of customers said a prescription wasn’t ready when promised at
          an independent pharmacy and just 4% complained of long waits. At
          pharmacy chains, 19% of customers found that a prescription wasn’t
          ready and 21% experienced long waits. In addition to encountering
          fewer delays, Consumer Reports also mentioned that independent
          pharmacy customers encountered fewer medication mix-ups than those who
          shopped elsewhere.
          <br />
          <br />
          3. <b> Consistent access to needed medicines. </b>Overall, almost 40%
          of consumers surveyed reported that a drug they needed was out of
          stock in the past year. Independents like Health Mart had fewer
          out-of-stock drugs than most major pharmacy outlets. In the event of
          an out-of-stock, as a group independent pharmacies were more likely
          than other types of pharmacies to restock a drug later the same day or
          the next day.
          <br />
          <br />
          4. <b>Individualized services customized to patients’ needs. </b>Many
          independent pharmacies offer compounding, or custom-mixing, services
          to tailor medications for individual patients. Consumer Reports gives
          the example that independent drug stores “can make a medication
          without a certain dye for a patient with an allergy or create a liquid
          version of a drug for a patient who has trouble swallowing pills.”
          Additionally, the article highlights that independents often stock
          specialized medical items such as durable medical equipment. In
          addition, independents are most likely to offer anytime delivery
          services.
        </LSubTitle>
        <BottomImageContainer>
          <BottomImage src={img1} alt="image" />
        </BottomImageContainer>
        <SubTitle>
          So, individuals who care about face-to-face service from pharmacists
          who offer personal advice based on knowing your particular health
          concerns, shorter wait times, consistent access to needed medications,
          and customized service may want to strongly consider switching to an
          independent pharmacy, as independents consistently outperform the
          chains in these areas.
        </SubTitle>
      </Inner>
      <BottomServiceBanner />
      <BottomBanner />
    </Container>
  );
};

export default PersonalAttention;

const ImgContainer = styled.div``;

const CardContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 1rem;
  padding: 1.5rem;

  &:hover p {
    opacity: 1;
  }
`;

const BottomImage = styled.img`
width: 65%;
`;

const BottomImageContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;

`;

const Container = styled.div``;
const Inner = styled.div``;

const SubTitle = styled.h2`
  font-size: 23px;
  font-weight: normal;
  line-height: normal;
  text-align: center;
  padding: 0rem 3rem 3rem 3rem;
  margin-top: 2rem;
  opacity: 0.6;

  @media (max-width: 600px) {
    font-size: 18px;
    padding-right: 0.5rem;
    padding-left: 0.5rem;
  }

  @media (max-width: 460px) {
    font-size: 15px;
  }
`;
const LSubTitle = styled.h2`
  font-size: 23px;
  font-weight: normal;
  line-height: normal;
  text-align: left;
  padding: 0rem 3rem 3rem 3rem;
  opacity: 0.6;

  @media (max-width: 600px) {
    font-size: 18px;
    padding-right: 0.5rem;
    padding-left: 0.5rem;
  }

  @media (max-width: 460px) {
    font-size: 15px;
  }
`;

const Middle = styled.div`
  background: var(--color-blue);
  clip-path: polygon(50% 10%, 100% 0, 100% 100%, 50% 90%, 0 100%, 0 0);
  padding: 10rem 0 10rem 0;
`;

const MiddleSubTitle = styled.h2`
  font-size: 20px;
  font-weight: normal;
  line-height: normal;
  color: white;
  text-align: center;
  margin-top: 1.5rem;

  @media (max-width: 600px) {
    font-size: 18px;
    padding-right: 0.5rem;
    padding-left: 0.5rem;
  }

  @media (max-width: 460px) {
    font-size: 15px;
  }
`;

const MiddleInner = styled.div`
  display: grid;
  align-items: center;
  justify-items: center;
  grid-template-columns: 3fr 2fr;
  padding: 0 5rem 0 5rem;

  @media (max-width: 1180px) {
  }
`;

const MiddleInnerLeft = styled.div`
  @media (max-width: 46px) {
    margin-bottom: 2rem;
  }
`;
const MiddleInnerRight = styled.div``;

const MiddleTextLeft = styled.h1`
  font-size: 30px;
  line-height: 1.1;
  color: white;
  text-align: center;

  @media (max-width: 600px) {
    font-size: 20px;
    margin-bottom: 2rem;
  }
`;

const Ul = styled.ul`
  display: grid;
  gap: 0.5rem;

  @media (max-width: 380px) {
    padding: 2rem 0.5rem 2rem 1.5rem;
  }
`;
const Li = styled.li`
  font-size: 1.2rem;
  letter-spacing: 1px;
  list-style: none;
  display: flex;
  align-items: center;
  gap: 0.5rem;
  color: white;

  @media (max-width: 600px) {
    font-size: 1.1rem;
    letter-spacing: normal;
    padding: 0rem 0.5rem 0rem 1.5rem;
  }

  @media (max-width: 460px) {
    font-size: 0.9rem;
  }
`;
const Img = styled.img`
  width: 100%;
  height: 100%;

  @media (max-width: 1180px) {
    width: 45%;
    height: 45%;
    margin-top: 1rem;
  }
`;

const Title = styled.h1`
  font-size: 40px;
  line-height: 1.1;
  color: var(--color-blue);
  text-align: center;
  margin-top: 3rem;

  &:hover {
    color: var(--color-red);
  }

  @media (max-width: 600px) {
    font-size: 30px;
  }
`;
